export const formatShopifyPrice = price =>
  Intl.NumberFormat(undefined, {
    currency: "GBP",
    minimumFractionDigits: 2,
    style: "currency",
  }).format(price)
